import api from '../../lib/configAxios';

export default {
  sendUsQuestions: async data => api.post(
    'PortalConnects/sendUsQuestions', data,
  ),
};
